export const ROL = {
  SUPERADMIN: "SUPERADMIN",
  FRANQUICIAADMIN: "FRANQUICIAADMIN",
  USER: "USER",
  PUBLIC: "PUBLIC",
  ADMIN: "ADMIN",
};
